import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { UseFormRegisterReturn } from "react-hook-form";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { Requisite } from "@/api/requisites/requisites.ts";

export function NewRequisitesHandbook(props: AutocompleteProps<Requisite>) {
  const items = useAppSelector((state) => state.handbooks.requisites);

  return (
    <Autocomplete
      defaultItems={items}
      label="Реквизиты"
      placeholder="Выберите реквизиты"
      variant="bordered"
      {...props}>
      {(item) => (
        <AutocompleteItem
          key={String(item.id)}
          textValue={`${item.displayName} (${item.bankName})`}>
          {`${item.displayName} (${item.bankName})`}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

export function RequisitesHandbook({
  register,
  isInvalid,
  errorMessage,
  defaultSelectedKey,
}: {
  register: UseFormRegisterReturn;
  isInvalid: boolean;
  errorMessage: string;
  defaultSelectedKey?: string;
}) {
  const items = useAppSelector((state) => state.handbooks.requisites);

  return (
    <Autocomplete
      {...register}
      defaultItems={items}
      label="Реквизиты"
      placeholder="Выберите реквизиты"
      variant="bordered"
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      defaultSelectedKey={defaultSelectedKey}>
      {(item) => (
        <AutocompleteItem
          key={String(item.id)}
          textValue={`${item.displayName} (${item.bankName})`}>{`${item.displayName} (${item.bankName})`}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
